<template>
  <div class="banner" v-if="itens.length > 0">
    <div class="relative w-full overflow-hidden rounded-lg shadow bg-default-400 h-vmax-15 mb-4 banner-height">
      <carousel :itens="itens"></carousel>
    </div>
  </div>
  <div class="banner" v-else></div>
</template>

<script type="ts">
import Carousel from "./global/Carousel";
import Semed from "../api/Semed";

export default {
  name: "BannerComponent",
  components: { Carousel },
  data() {
    return {
      itens: {},
    }
  },
  created() {
    this.getBanners("/education/banners");
  },
  methods: {
    getBanners(link) {
      Semed.get(link).then((response) => {
        this.itens = response.data;
      });
    },
  }
};
</script>

<style scoped>
  .banner-height {
    max-height: 350px;
  }
</style>

